import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import ProductListUi from './ProductListUi';
import {PRODUCT_LIST_TYPE} from '../../../../constants/commons';
import {reset} from '../../../../redux/slices/dynamicMultipleElementsSlice';
import CustomTimer from "../../../../components/CustomTimer";

const FlashSaleList = ({mobile}) => {
  const flashSaleData = useSelector(
    (state) => state.dynamicMultipleElements.products.flashSale
  );

  const dispatch = useDispatch();

  const onFlashSaleOver = useCallback(
    (s) => {
      dispatch(reset({element: 'products', id: 'flashSale'}));
    },
    [dispatch]
  );

  return (
    <div className="w-full relative flash-sale app-top-mg">
      <div className="app-side-pd">
        <div
          className={`gradient-flash-sale rounded-full flex justify-between items-center ${
            mobile
              ? 'h-[69px] px-3 space-x-8'
              : 'flash-sale-height mb-2.5'
          } space-x-8`}
        >
          <div
            className={`ml-3 relative flex items-center ${
              mobile ? 'space-x-3' : 'space-x-2 2xl:space-x-4 px-10'
            }`}
          >
            <img
              src={
                mobile
                  ? '/images/flash-sale-logo-mobile.png'
                  : '/images/flash-sale-logo-web.png'
              }
              alt="Flash Sale"
              className={`${mobile ? 'w-12' : 'mr-4 flash-sale-logo-web'} shrink-0`}
            />
            <img
              src="/images/flash-sale-lightning.png"
              alt="Flash Sale"
              className={`${
                mobile ? 'w-[50px]' : 'mr-4 flash-sale-lightning-web'
              } aspect-[117/161] h-full`}
            />

            <CustomTimer endDate={flashSaleData?.meta?.endsIn} onTimeUp={onFlashSaleOver} mobile={mobile}/>
          </div>
          <div
            className={`${
              mobile ? 'text-xs' : 'text-base'
            } cursor-pointer text-dark shrink-0`}
          >
            View all
          </div>
        </div>
      </div>
      <ProductListUi
        productData={flashSaleData}
        mobile={mobile}
        type={PRODUCT_LIST_TYPE.sale}
        hasViewAllBtn={false}
      />
    </div>
  );
};

export default React.memo(FlashSaleList);

